module.exports = __webpack_public_path__ + "_assets/img/point.e82a0245.svg";